function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { Controls, validators } from 'shared/helper/form';
import { T, useTranslate } from 'shared/helper/translate';
var styles = {
  wrapper: 'mb-3'
};
var notEmpty = validators.notEmpty;
var Select = Controls.Select;
var PaymentCurrency = function PaymentCurrency(_ref) {
  var defaultCurrency = _ref.defaultCurrency,
    defaultCurrencySelected = _ref.defaultCurrencySelected,
    merchantAccounts = _ref.merchantAccounts;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    displayCurrencySelection = _useState2[0],
    setDisplayCurrencySelection = _useState2[1];
  if (!displayCurrencySelection) {
    return /*#__PURE__*/React.createElement("div", {
      className: "col-12 clearfix"
    }, /*#__PURE__*/React.createElement("div", {
      className: "p-2 default-currency-display"
    }, /*#__PURE__*/React.createElement("button", {
      "aria-label": t('change'),
      type: "button",
      onClick: function onClick() {
        return setDisplayCurrencySelection(true);
      },
      className: "float-end btn-link text-uppercase"
    }, /*#__PURE__*/React.createElement(T, {
      source: "change"
    })), /*#__PURE__*/React.createElement(T, {
      source: "Payment currency: %s",
      params: t(defaultCurrency.label)
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Select, {
    label: "What currency would you like to pay with?",
    description: "Credit card currency restrictions",
    messages: {
      notEmpty: 'Please select a payment currency'
    },
    name: "creditCard[currency]",
    options: merchantAccounts,
    defaultValue: defaultCurrency,
    validators: {
      notEmpty: notEmpty
    },
    styles: styles
  }), !defaultCurrencySelected ? /*#__PURE__*/React.createElement("div", {
    className: "alert alert-warning mt-0 mb-2"
  }, /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "alternate-payment-currency-selected"
  })) : null);
};
export default PaymentCurrency;